(function () {
  const FIRST_KEY = 'manifest_attribution_first';
  const LAST_KEY = 'manifest_attribution_last';

  // Guardamos la atribución durante 30 días
  const EXPIRATION_TIME = 30 * 24 * 60 * 60 * 1000;

  const attributionParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'campaign_id',
    'adset_id',
    'ad_id',
    'placement',
    'fbclid'
  ];

  function readAttribution(key) {
    try {
      const stored = localStorage.getItem(key);

      if (!stored) return null;

      const data = JSON.parse(stored);

      if (
        !data.saved_at ||
        Date.now() - data.saved_at > EXPIRATION_TIME
      ) {
        localStorage.removeItem(key);
        return null;
      }

      return data;
    } catch (e) {
      return null;
    }
  }

  function saveAttribution(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {}
  }

  function getCurrentAttribution() {
    const urlParams = new URLSearchParams(window.location.search);
    const data = {};
    let found = false;

    attributionParams.forEach(function (param) {
      const value = urlParams.get(param);

      if (value) {
        data[param] = value;
        found = true;
      }
    });

    if (!found) return null;

    data.landing_page = window.location.pathname;
    data.saved_at = Date.now();

    return data;
  }

  const currentAttribution = getCurrentAttribution();

  if (currentAttribution) {
    // PRIMER anuncio que trajo al cliente
    if (!readAttribution(FIRST_KEY)) {
      saveAttribution(FIRST_KEY, currentAttribution);
    }

    // ÚLTIMO anuncio por el que volvió a entrar
    saveAttribution(LAST_KEY, currentAttribution);
  }

  // Lo dejamos disponible para usarlo luego
  // en el botón Comprar por WhatsApp
  window.ManifestAttribution = {
    getFirst: function () {
      return readAttribution(FIRST_KEY);
    },

    getLast: function () {
      return readAttribution(LAST_KEY);
    }
  };
})();


  function manifestShortRef(adName) {
  if (!adName) return '';

  const words = adName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .split(/[^A-Z0-9]+/)
    .filter(Boolean)
    .filter(function (word) {
      return !/^\d+$/.test(word) || word.length === 1;
    });

  return words
    .map(function (word) {
      return word.charAt(0);
    })
    .join('')
    .slice(0, 6);
}

document.addEventListener('click', function (event) {
  const whatsappButton = event.target.closest(
    '[data-manifest-whatsapp="cart"]'
  );

  if (!whatsappButton) return;

  try {
    const attribution =
      window.ManifestAttribution &&
      window.ManifestAttribution.getLast
        ? window.ManifestAttribution.getLast()
        : null;

    if (!attribution || !attribution.utm_content) return;

    const url = new URL(whatsappButton.href);
    let message = url.searchParams.get('text') || '';

    message = message.replace(/\n\nRef:.*$/s, '');

    const reference = manifestShortRef(attribution.utm_content);

    if (!reference) return;

    message += '\n\nRef: ' + reference;

    url.searchParams.set('text', message);
    whatsappButton.href = url.toString();

  } catch (error) {
    console.error('Manifest attribution:', error);
  }
});